"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateZodSchema = void 0;
const ZodError_1 = require("../ZodError");
/**
 * This function is used to generate the path from the zod issue
 */
const generatePathFromZodIssue = (error) => error.path.reduce((propertyPath, pathChunk) => {
    if (typeof pathChunk === "number") {
        propertyPath += `[${pathChunk}]`;
    }
    else {
        propertyPath += propertyPath.length ? `.${pathChunk}` : pathChunk;
    }
    return propertyPath;
}, "");
/**
 * This function is used to safely parse the data
 */
const safeParsedData = (data) => {
    try {
        return JSON.parse(data);
    }
    catch (_a) {
        return null;
    }
};
/**
 * This function is used to add extra validation to the zod schema
 */
const addExtraValidation = (schema, extraValidation) => schema.superRefine((internalData, context) => {
    if (internalData && typeof internalData === "object") {
        Object.keys(internalData).forEach((key) => {
            var _a;
            const parsedKey = key;
            const customParameter = extraValidation[parsedKey];
            if (customParameter) {
                const resultCustomValidation = customParameter.customValidator(internalData[parsedKey]);
                if (!resultCustomValidation) {
                    context.addIssue({
                        path: [key],
                        code: "custom",
                        message: (_a = customParameter.errorMessage) !== null && _a !== void 0 ? _a : "Custom validation failed",
                    });
                }
            }
        });
    }
});
/**
 * This function is used to validate the zod schema
 */
const validateZodSchema = (schema, data, extraValidation) => {
    let parsedData = data;
    if (typeof data === "string") {
        parsedData = safeParsedData(data);
    }
    if (extraValidation) {
        schema = addExtraValidation(schema, extraValidation);
    }
    const result = schema.safeParse(parsedData);
    if (!result.success) {
        const errors = result.error.errors.map((error) => {
            const path = generatePathFromZodIssue(error);
            return `"${path ? path : "root"}": ${error.message}`;
        });
        throw new ZodError_1.ZodError(errors);
    }
    return result.data;
};
exports.validateZodSchema = validateZodSchema;
//# sourceMappingURL=validateZodSchema.js.map